import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Observable } from 'rxjs';
import { CheckboxGridRow } from '../../checkbox-grid.model';

@Component({
  selector: 'checkbox-row-wrapper',
  templateUrl: './checkbox-row-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxRowWrapperComponent implements OnChanges {
  @Input() rows$: Observable<CheckboxGridRow[]>;
  ownRows$;

  ngOnChanges(sc: SimpleChanges) {
    this.ownRows$ = this.rows$;
  }
}
